module.exports = __webpack_public_path__ + "img/Considerate Carer.0bec783d.png";